import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ApplicationModel, CategoryModel, CommonLabels } from 'app/common/models/common.model';

import { ResizeWindowService } from 'app/common/services/resize-window.service';
import { CategoriesStoreService } from '../../../common/services/category-observable.service';
import { MatTabGroup } from '@angular/material/tabs';
import { StorageService } from '../../../common/services/storage.service';
import { UtilsService } from '../../../common/services/utils.service';
import { Subscription } from 'rxjs';
import { removeFromLibraryLabels } from '../../../common/common.labels';

@Component({
  selector: 'app-application-detail',
  templateUrl: './application-detail.component.html',
  styleUrls: ['./application-detail.component.scss']
})
export class ApplicationDetailComponent implements OnInit, OnDestroy {
  theme = 'marketplace-default';
  className = 'app-application-detail';
  isDesktop: boolean = false;
  width: number = 0;
  @Input() categoriesList: CategoryModel[];
  @Input() labels: CommonLabels;
  @Input() categoryPurchasedId: string;
  @Input() categoryMostPurchasedId?: string;
  @Input() categoryFeaturedId?: string;
  @Input() categorySuggestedId?: string;
  @Input() categorySpecialId?: string;
  @Input() categoryFeatured?: CategoryModel;
  @Input() categorySuggested?: CategoryModel;
  @Input() categorySpecial?: CategoryModel;
  @Input() categoryPurchased?: CategoryModel;
  @Input() categoryMostPurchased?: CategoryModel;
  @Input() arrayApplicationFeatured?: any = [];
  @Input() dataApplication: ApplicationModel;
  @Input() disabledButton: boolean;
  @Input() showContactButton: boolean;
  @Input() showAddToLibraryButton: boolean;
  @Input() showAlreadyInLibraryButton: boolean;
  // US-06 (727) — botón "Remove from library" y sus estados.
  @Input() showRemoveFromLibraryButton: boolean;
  @Input() removeBlockedByInstances: boolean;
  @Input() isAddingApp: boolean;
  @Input() isRemovingApp: boolean;
  @Input() typeModal: string;

  @Output() emitAddToLibrary: EventEmitter<{ id: string; typeModal: string }> = new EventEmitter();
  @Output() emitRemoveFromLibrary: EventEmitter<void> = new EventEmitter();
  @Output() emitContact: EventEmitter<{ id: string; typeModal: string }> = new EventEmitter();
  @Output() emitClickMore: EventEmitter<{ id: string }> = new EventEmitter();
  @ViewChild('tabList', { static: false }) tabList: MatTabGroup;

  isLoading: boolean = false;
  tabSelectedIndex: number = 0;
  lastVersion: number = 0;
  readme: string = '';
  showBarbara: boolean = false;
  showMostUsed: boolean = false;
  showFeatured: boolean = false;
  menuState: string = '';
  title: string;
  shortDescription: string;
  hasCategoryStandard: boolean = false;
  removeFromLibraryLabels = removeFromLibraryLabels;
  arraySubscriptions: Subscription[] = [];

  /**
   * pictures[0] es la cover histórica (banner) — el carrusel solo muestra
   * a partir de la segunda imagen.
   */
  get carouselImages(): string[] {
    const pictures = this.dataApplication?.pictures;
    return Array.isArray(pictures) ? pictures.slice(1) : [];
  }
  showBreadcrumb: boolean = false;

  constructor(
    private resizeWindowService: ResizeWindowService,
    private readonly router: Router,
    private storageService: StorageService,
    private categoriesStoreService: CategoriesStoreService,
    public utilsService: UtilsService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.goTop();
    this.initSubscriptions();
  }

  goTop() {
    const drawer = document.getElementsByClassName('mat-drawer-content')[0] as HTMLElement | undefined;
    drawer?.scrollTo(0, 0);
  }

  initSubscriptions() {
    this.arraySubscriptions.push(
      this.resizeWindowService.isDesktop$.subscribe((value: boolean) => {
        this.isDesktop = value;
      })
    );
    this.arraySubscriptions.push(
      this.resizeWindowService.width$.subscribe((value: number) => {
        this.width = value;

        this.resizeWindowService.waitForFinalEvent(
          () => {
            this.width = value;
            if (
              this.dataApplication.versions !== undefined &&
              this.dataApplication.versions.length > 0
            ) {
              /* El back devuelve las versiones de más antigua a más nueva, así que la
                 "actual" es la última del array — mismo criterio que ListAppComponent.
                 `NewVersionDialogComponent` depende de esto para su preview: coloca la
                 versión en edición al final para que el detalle la muestre. */
              this.lastVersion = this.dataApplication.versions.length - 1;
              if (
                this.dataApplication.versions[this.lastVersion].readme !== '' &&
                this.dataApplication.versions[this.lastVersion].readme !== null &&
                this.dataApplication.versions[this.lastVersion].readme !== undefined
              ) {
                this.readme = this.utilsService.conversorString(
                  this.dataApplication.versions[this.lastVersion].readme
                );
              }
            }
            this.dataApplication.categories.forEach((category) => {
              let _temp = this.categoriesList.find((cat) => cat._id === category._id);
              category.description = _temp.description;
              category.icon = _temp.icon;
              category.order = _temp.order;
              category.type = _temp.type;
              if (category.type === 0 && !this.hasCategoryStandard) {
                this.hasCategoryStandard = true;
                this.showBreadcrumb = localStorage.getItem('isAdmin') !== 'true';
                this.storageService.resetBread();
                this.storageService.setBread('home', 'home', 'Home', undefined);
                this.storageService.setBread('category-detail', '', category.name, category._id);
              }
              if (category.type === 1) {
                this.showFeatured = true;
              }
              if (category.type === 2) {
                this.setPurchasedApplication();
              }
              if (category.type === 3) {
                this.showMostUsed = true;
              }
              if (category.type === 4) {
                this.showBarbara = true;
              }
            });
            this.categoriesStoreService.getStateMenu().subscribe((state) => {
              this.menuState = state;
              this.title = this.dataApplication.name.replace(/<[^>]*>/g, '');
              this.shortDescription = this.dataApplication.shortDescription.replace(/<[^>]*>/g, '');
              this.isLoading = false;
            });
          },
          10,
          'loadingAppDetail'
        );
      })
    );
  }

  setPurchasedApplication() {
    this.dataApplication.purchased = true;
  }

  addToLibrary(id: string, typeModal): void {
    this.emitAddToLibrary.emit({ id: id, typeModal: typeModal });
  }

  removeFromLibrary(): void {
    this.emitRemoveFromLibrary.emit();
  }

  contact(id: string, typeModal): void {
    this.emitContact.emit({ id: id, typeModal: typeModal });
  }

  onClickMoreButton(id: string): void {
    this.storageService.removeStorePersistentSearch();
    this.emitClickMore.emit({ id: id });
  }

  selectedTabChange(event) {
    this.tabSelectedIndex = event.index;
  }

  identify(index, item) {
    return index;
  }

  removeSubscriptions() {
    this.arraySubscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  ngOnDestroy() {
    this.removeSubscriptions();
  }
}